import * as React from 'react';
import { getConfig } from '../config';
import { useShowTag } from '../hooks/ad';
import { getBannerProximityByPlacementId } from '../utils/banner-proximity';
import { PlacementId } from '../../shared/types/ast';
import { useMemo } from 'react';

export type Props = {
    id: string;
    targetId: string;
    pageType?: string;
    className?: string;
    deviceType?: string;
    vertical?: string;
    adSize?: {
        width: number;
        height: number;
    };
};

export function Banner(props: Props) {
    const {
        id,
        targetId,
        pageType,
        className = 'ads__unit ads__unit--banner ads__unit--fullwidth',
        adSize,
    } = props;

    const { proximity = 0, threshold = 0.0 } = useMemo(() => {
        return getBannerProximityByPlacementId(id as PlacementId, adSize);
    }, [id, adSize]);

    useShowTag(targetId, proximity, threshold);

    if (pageType && pageType === 'object') {
        // Rendered from objectpages-podium already
        return null;
    }
    const { vertical } = getConfig();
    let containerClassName = className;
    let boardClassName = `inline-container ${id}-inline-container`;

    // These styles apply only to some verticals because the new styles are applied there.
    // The other verticals will forego a transition to these new styles eventually.
    // After adding these styles, it means removing the ads__unit styling from the components
    if (vertical === 'realestate' && pageType === 'result') {
        containerClassName =
            'grid overflow-hidden relative transition-all outline-none mt-24 mx-16 mb-16 sm:mb-24';
        boardClassName = 'inline mx-auto';
    }
    return (
        <div id={`${targetId}-container`} className={containerClassName}>
            <div id={targetId} className={boardClassName}>
                <span className="ad-info-wrap">
                    <div
                        id={`${targetId}-button`}
                        className="ad-info"
                        style={{ maxWidth: 26, maxHeight: 26 }}
                    />
                </span>
            </div>
        </div>
    );
}
